import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$(".solution-nav ul li").eq(0).addClass("active");
$(".solution-list a").eq(0).addClass("active");
$(".solution-nav ul li").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".solution-list a").eq(index).addClass("active").siblings().removeClass("active");
})

var honor = new Swiper(".section8 .mySwiper", {
    slidesPerView: 5,
    spaceBetween: '1.21%',
    loop:true,
    speed:2000,//匀速时间
    autoplay: {
    	delay: 0,
    	stopOnLastSlide: false,
    	disableOnInteraction: false,
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 5,
        spaceBetween: '1.21%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        spaceBetween: '1.21%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      }
    } 
});